export default "/_assets/arrow_disabled.85d81f54.svg"